module.exports = __webpack_public_path__ + "img/visual-02.71d62548.png";